<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">{{'MENU.DISHES.NEW.EDIT_TAG' | translate}}
    </div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>
  <form [formGroup]="form">

    <div>
      <app-select-image-field
        [allowOverrides]="true"
        [image]="selectedTagImgSrc"
        [overrideUrl]="data.tag.externalPictureUrl"
        [organizationId]="data.organization.id"
        (imageChanged)="onImageChanged($event)"
      ></app-select-image-field>
    </div>

    <mat-form-field class="dish-name" appearance="fill">
      <mat-icon *ngIf="isNameDifferent()" (click)="restoreName()">restore</mat-icon>
      <mat-label>{{'MENU.ALLERGEN_GROUP.NAME' | translate}}</mat-label>
      <input matInput type="text" formControlName="tagName" [class.isDifferent]="isNameDifferent()">
      <label class="error" *ngIf="form.hasError('tagName')">{{form.errors['tagName']}}</label>
    </mat-form-field>

    <div *ngIf="data.organization.additionalLanguages">
      <mat-form-field class="dish-name" appearance="fill"
                      *ngFor="let lang of data.organization.additionalLanguages">
        <mat-label>{{ 'MENU.ALLERGEN_GROUP.TRANSLATION' | translate }} {{ lang }}</mat-label>
        <input matInput type="text" formControlName="{{lang}}">
      </mat-form-field>
    </div>

    <mat-form-field class="dish-name" appearance="fill">
      <mat-label>{{'MENU.TEXT_COLOR' | translate}}</mat-label>
      <input matInput type="text" formControlName="textColor">
    </mat-form-field>

    <mat-form-field class="dish-name" appearance="fill">
      <mat-label>{{'MENU.BACKGROUND_COLOR' | translate}}</mat-label>
      <input matInput type="text" formControlName="backgroundColor">
    </mat-form-field>

    <div>
      <span>
        <span>{{ 'MENU.ALLERGEN_GROUP.IS_MANUALLY_CREATED' | translate }}</span>
        <input type="checkbox" formControlName="isManuallyCreated"/>
      </span>
    </div>

    <div class="form-bottom" style="display: flex">
      <button
        class="button"
        mat-button
        type="submit"
        style="flex: auto"
        (click)="submit()"
      >{{ 'MENU.SAVE' | translate }}
      </button>

      <button
        *ngIf="isManuallyCreated()"
        mat-button
        type="button"
        (click)="remove()"
        style="flex: auto"
      >{{ 'MENU.DELETE' | translate }}
      </button>
    </div>
  </form>
</div>
